import { ReconfigureAgentTypeFormController } from '../controller/ReconfigureAgentTypeFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { ReconfigureAgentType } from '../types';

export class ReconfigureAgentTypeFormWebComponent extends BaseWebComponentElement {
  public controller!: ReconfigureAgentTypeFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ReconfigureAgentTypeFormController,
    });
  }

  public get selectedOperation(): ReconfigureAgentType {
    return this.controller.view.dom.$reconfigureAgentTypeFormField.Input.getFormValue() as ReconfigureAgentType;
  }
}
